module.exports = __webpack_public_path__ + "assets/img/29_259_big.551d75f9.jpg";